export const TENANT_ID = "quest";

export const MASONRY = {
  ROOT_NODE_ID_HOME_PAGE: "homepage$root",
  ROOT_NODE_ID_SCREENINGS: "screenings$root",
  ROOT_NODE_ID_MY_RESULTS: "myResults$root",
  ROOT_NODE_ID_PHYSICIAN_RESULTS_DOWNLOAD_FORM:
    "screenings$selfScreening$downloadForm$root",
  ROOT_NODE_ID_PHYSICIAN_RESULTS_UPLOAD_FORM:
    "screenings$selfScreening$uploadForm$root",
  ROOT_NODE_ID_HQS_DETAILS: "myResults$hqs$quotientScoreDetails",
  ROOT_NODE_ID_RESOURCES: "resources$landingPage$root",
  ROOT_NODE_ID_RESOURCE_DETAIL: "resources$detailPage$details",
  ROOT_NODE_ID_CONTACT_US: "customerSupport$root",
  ROOT_NODE_ID_LEARN_WHY_SCREENINGS_IMPORTANT:
    "resources$learn$whyScreeningsImportant$root",
  ROOT_NODE_ID_LEARN_HOW_TO_SHARE_RESULTS:
    "resources$learn$howToShareResults$root",
  ROOT_NODE_ID_EXPLORE: "careLibrary$root",
  ROOT_NODE_ID_CARE_LIBRARY_TOPIC_PAGE: "careLibrary$topicPage",
  ROOT_NODE_ID_CARE_LIBRARY_SEARCH: "careLibrary$search",
  ROOT_NODE_ID_FEATURE_HIGHLIGHTS: "highlights$root",
  ROOT_NODE_ID_ADDED_BY_ME: "journey$addedByMe$root",
  ROOT_NODE_ID_SCREENINGS_SCHEDULE: "screenings$scheduling$selectDateTime$root",
  ROOT_NODE_ID_SELF_COLLECTION_SELECTION: "selfCollection$selection$root",
  ROOT_NODE_ID_SELF_COLLECTION_ADDRESS_CONFIRMATION:
    "selfCollection$addressConfirmation$root",
  ROOT_NODE_ID_SELF_COLLECTION_ORDER_PLACED: "selfCollection$orderPlaced$root",
  ROOT_NODE_ID_SELF_COLLECTION_CANCELLATION: "selfCollection$cancellation$root",
  ROOT_NODE_ID_SELF_COLLECTION_ORDER_CANCELLED:
    "selfCollection$orderCancelled$root",
  ROOT_NODE_ID_SELF_COLLECTION_INSTRUCTIONS: "selfCollection$instructions$root",
  ROOT_NODE_ID_SELF_COLLECTION_ACTIVATION: "selfCollection$activation$root",
  ROOT_NODE_ID_SELF_COLLECTION_ACTIVATION_FORM:
    "selfCollection$activationForm$root",
  ROOT_NODE_ID_SELF_COLLECTION_ACTIVATION_COMPLETE:
    "selfCollection$activationComplete$root",
};

export const QUERY_PARAM_MODAL_VALUE = {
  DELETE_ACCOUNT: "delete-account",
  DELETE_ACCOUNT_DISCLAIMER: "delete-account-disclaimer",
};

export enum QUERY_PARAM_KEYS {
  MODAL = "modal",
}

export const ANALYTICS_DETAILS = {
  CANCEL: "cancel",
  CONFIRM_DELETION: "confirm deletion",
  ACKNOWLEDGE_DELETION: "acknowledge deletion",
};

export const ANALYTICS_SCREEN_NAMES = {
  DELETION_CONFIRMATION: "deletion confirmation",
};

export const PAGE_HEADER_HEIGHT = {
  MOBILE: "96px",
  DESKTOP: "156px",
};

export const PAGE_CONTENT_MAX_WIDTH = "840px";

export const JOURNEY_CONTENT_MAX_WIDTH = "996px";

export const SCREENINGS_SCHEDULE_CONTENT_MAX_WIDTH = "960px";

export const ACCOUNT_SETUP_STEPS = {
  CONSENT: "consent",
  NOTIFICATIONS: "notifications",
  GET_STARTED: "get-started",
  HIGHLIGHTS: "highlights",
} as const;
